// src/locales/si/callCenterShifts.js
export const callCenterShifts = {
  pageTitle: 'ඇමතුම් මධ්‍යස්ථාන මුරප්පාර',
  pageDescription: 'ඇමතුම් මධ්‍යස්ථාන මුරප්පාර සකසන්න සහ එක් එක් කාර්ය මණ්ඩල සාමාජිකයා සඳහා හරස්-විකුණුම් ඉලක්ක සකසන්න',
  newShift: 'නව මුරය',
  editShift: 'මුරය සංස්කරණය කරන්න',
  createShift: 'මුරය සාදන්න',
  saveShift: 'මුරය සුරකින්න',
  shiftDate: 'මුර දිනය',
  staffCount: 'කාර්ය මණ්ඩල ගණන',
  totalTarget: 'මුළු ඉලක්කය',
  achievedSalesValue: 'ලබාගත් විකුණුම්',
  totalCommission: 'මුළු කොමිසම',
  estimate: 'ඇස්තමේන්තුව',
  liveEstimateNote: 'මෙම අගය සජීවී ඇස්තමේන්තුවකි — මාසය අවසන් කළ පසු එය ස්ථිර වේ.',
  detailsPageTitle: 'මුර විස්තර',
  detailsPageDescription: 'කාර්ය මණ්ඩල ඉලක්ක, ලබාගත් හරස්-විකුණුම් අගය සහ මෙම මුරය සඳහා කොමිසම',
  staffCommissionBreakdown: 'කාර්ය මණ්ඩල කොමිස් වර්ගීකරණය',
  crossSoldItems: 'හරස්-විකුණන ලද අයිතම',
  noCrossSellItemsForShift: 'මෙම මුරයට හරස්-විකුණන ලද අයිතම තවම නොමැත',
  crossSellQuantity: 'ප්‍රමාණය',
  lineValue: 'පේළි අගය',
  failedToLoadShiftDetails: 'මුර විස්තර පූරණය කිරීමට අසමත් විය',
  failedToLoadCrossSellItems: 'හරස්-විකුණන ලද අයිතම පූරණය කිරීමට අසමත් විය',
  filterByDateRange: 'මුර දින පරාසය',
  allShiftDates: 'සියලුම මුර දින',
  noShiftsFound: 'මුරප්පාර හමු නොවීය',
  noShiftsFoundDescription: 'ඔබගේ පෙරහන් සකස් කරන්න හෝ නව මුරයක් සාදන්න',
  noShiftsYet: 'තවම මුරප්පාර සකසා නැත',
  noShiftsYetDescription: 'ආරම්භ කිරීමට ඔබගේ පළමු මුරය සාදන්න',
  shiftCreatedSuccess: 'මුරය සාර්ථකව සාදන ලදී',
  shiftUpdatedSuccess: 'මුරය සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToLoadShifts: 'මුරප්පාර පූරණය කිරීමට අසමත් විය',
  failedToLoadUsers: 'ව්‍යාපාරික පරිශීලකයින් පූරණය කිරීමට අසමත් විය',
  failedToSaveShift: 'මුරය සුරැකීමට අසමත් විය',
  shiftStaff: 'මුර කාර්ය මණ්ඩලය',
  addStaff: 'කාර්ය මණ්ඩලය එකතු කරන්න',
  removeStaff: 'ඉවත් කරන්න',
  staffMember: 'කාර්ය මණ්ඩල සාමාජිකයා',
  targetValue: 'ඉලක්ක අගය',
  selectUser: 'පරිශීලකයෙකු තෝරන්න',
  edit: 'සංස්කරණය',
  viewDetails: 'විස්තර බලන්න',
  editSlabs: 'ස්ලැබ් සංස්කරණය කරන්න',
  commissionSlabs: 'කොමිස් ස්ලැබ් (විකුණුම් අගය අනුව)',
  slabsHelp: 'මෙම ස්ලැබ් සෑම මුරයක් සඳහාම හරස්-විකුණුම් කොමිසම ගණනය කිරීමට භාවිතා වේ. වෙනස්කම් සුරැකීමෙන් පසුව සාදන ලද මුරප්පාර සඳහා පමණක් අදාළ වේ — දැනටමත් සාදන ලද මුරප්පාර ඒවා සාදන අවස්ථාවේ පැවති ස්ලැබ් අනුපාත රඳවා ගනී.',
  addSlab: 'ස්ලැබ් එකතු කරන්න',
  removeSlab: 'ස්ලැබ් ඉවත් කරන්න',
  saveSlabs: 'ස්ලැබ් සුරකින්න',
  slabMinValue: 'අවම අගය',
  slabMaxValue: 'උපරිම අගය',
  slabRate: 'අනුපාතය (%)',
  openEnded: 'විවෘත අන්තයි',
  slabsSavedSuccess: 'කොමිස් ස්ලැබ් සාර්ථකව සුරකින ලදී',
  failedToSaveSlabs: 'කොමිස් ස්ලැබ් සුරැකීමට අසමත් විය',
  commissionCalculation: 'කොමිස් ගණනය කිරීම',
  minValue: 'අවම අගය',
  maxValue: 'උපරිම අගය',
  amountPerUnit: 'ඒකකයකට මුදල',
  slabQty: 'ස්ලැබ් ප්‍රමාණය',
  slabTotal: 'ස්ලැබ් එකතුව',
  noSlabsConfigured: 'මෙම මුරය සඳහා කොමිස් ස්ලැබ් වින්‍යාස කර නොමැත',
  searchCrossSoldItems: 'ඇණවුම් අංකය හෝ එයාර්වේබිල් සොයන්න...',
  placeholders: {
    targetValue: 'e.g. 30000',
  },
  validation: {
    staffRequired: 'Add at least one staff member',
    targetRequired: 'Target value is required',
    targetPositive: 'Target value must be greater than 0',
    shiftDateRequired: 'මුර දිනය අවශ්‍යයි',
    staffUserRequired: 'සෑම පේළියක් සඳහාම කාර්ය මණ්ඩල සාමාජිකයෙකු තෝරන්න',
    targetValueInvalid: 'ඉලක්ක අගය වලංගු ධන සංඛ්‍යාවක් විය යුතුය',
    slabMinValueInvalid: 'අවම අගය වලංගු ධන සංඛ්‍යාවක් විය යුතුය',
    slabRateInvalid: 'අනුපාතය වලංගු ධන සංඛ්‍යාවක් විය යුතුය',
    slabMaxValueRequired: 'අවසාන ස්ලැබ් හැර සෑම ස්ලැබ් එකකටම උපරිම අගය අවශ්‍යයි',
    fixErrors: 'සුරැකීමට පෙර දක්වා ඇති දෝෂ නිවැරදි කරන්න',
  },
};
